export enum MessageType {
	ANALYTICS = 'analytics',
	LOGS = 'logs'
}
